import { gql } from "@apollo/client";
//import { FEATURED_ASSET } from "./fragments/featured-asset.fragment";

export const CartQuery = gql`
  query {
    activeOrder {
      id
      code
      state
      active
      customer {
        id
        firstName
        lastName
        emailAddress
        phoneNumber
        title
      }
      lines {
        id
        unitPrice
        unitPriceWithTax
        linePrice
        linePriceWithTax
        quantity
        productVariant {
          id
          sku
          name
          price
          priceWithTax
          product {
            name
            slug
          }
        }
      }
      billingAddress {
        fullName
        streetLine1
        streetLine2
        city
        province
        postalCode
        country
        countryCode
        phoneNumber
      }
      shippingAddress {
        fullName
        streetLine1
        streetLine2
        city
        province
        postalCode
        country
        countryCode
        phoneNumber
      }
      discounts {
        type
        description
        amount
        amountWithTax
      }
      shippingLines {
         shippingMethod {
           id 
           name
           description
           code
         } 
      }
      shipping
      shippingWithTax
      total
      totalWithTax
    }
  }
`;
